import { z } from "zod";

export const TransitionKind = z.enum([
  "NONE",
  "FADE",
  "FADE_BLACK",
  "FADE_WHITE",
  "PUSH",
  "WIPE",
  "ZOOM_IN_FADE",
  "ZOOM_IN_OUT",
  "ZOOM_BLUR",
  "ZOOM_OUT_BLUR",
  "GLITCH_CUT",
  "FOCUS_PULL",
  "WHIP_PAN",
  "CLOCK_WIPE",
  "SPLIT_REVEAL",
  "SPLIT_SCREEN_WIPE",
  "LIGHT_LEAK",
]);

export const TransitionSpeed = z.enum(["SLOW", "NORMAL", "FAST"]);
export const TransitionDirection = z.enum([
  "FROM_LEFT",
  "FROM_RIGHT",
  "FROM_TOP",
  "FROM_BOTTOM",
  "FROM_TOP_RIGHT",
  "FROM_TOP_LEFT",
  "FROM_BOTTOM_RIGHT",
  "FROM_BOTTOM_LEFT",
]);

export const MAX_TRANSITION_SEED = 2147483647;

export const TransitionDto = z.object({
  kind: TransitionKind,
  speed: TransitionSpeed.optional(),
  direction: TransitionDirection.optional(),
  intensity: z.number().min(0).max(1).optional(),
  seed: z.number().int().min(0).max(MAX_TRANSITION_SEED).optional(),
});

export type TransitionKind = z.infer<typeof TransitionKind>;
export type TransitionSpeed = z.infer<typeof TransitionSpeed>;
export type TransitionDirection = z.infer<typeof TransitionDirection>;
export type TransitionDto = z.infer<typeof TransitionDto>;
